import _ from "lodash";
import { useEffect, useState } from "react";

import { UseForm } from "./types";

export const useForm = <T>(initForm?: T): UseForm<T> => {
  const [form, setForm] = useState<T>(initForm);

  useEffect(() => {
    setForm(initForm);
  }, []);

  const onChangeInput = (event: any) => {
    const target = event?.target;
    const type = target?.type;
    const name = target?.name;

    const getValue = () => {
      if (type === "checkbox") {
        return target?.checked ? target?.id : null;
      }
      if (type === "radio") {
        return target?.checked ? target?.id : null;
      } else if (type === "file") {
        return target?.files ? target?.files[0] : null;
      } else {
        return target?.value;
      }
    };

    setForm((state: T) => {
      let value = getValue();

      if (type === "checkbox") {
        if (value) {
          value = [...state[name], value];
        } else {
          if (state[name].filter) {
            value = state[name].filter((key) => key !== target?.id);
          }
        }
      }

      return {
        ...state,
        [name]: value,
      };
    });
  };

  const isChecked = (key: keyof T, value: string): boolean => {
    if (_.isArray(form[key])) {
      if ((form[key] as any as string[]).find) {
        return !!(form[key] as any as string[]).find((id) => id === value);
      }
      return false;
    } else {
      return (form[key] as any) === value;
    }
  };

  return {
    form,
    onChangeInput,
    setForm,
    isChecked,
  };
};
